import { render, staticRenderFns } from "./OptInPage.vue?vue&type=template&id=1904b8fe&scoped=true&"
import script from "./OptInPage.vue?vue&type=script&lang=js&"
export * from "./OptInPage.vue?vue&type=script&lang=js&"
import style0 from "./OptInPage.vue?vue&type=style&index=0&id=1904b8fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904b8fe",
  null
  
)

export default component.exports